import { render, staticRenderFns } from "./communicationDashboard.vue?vue&type=template&id=308c8420"
import script from "./communicationDashboard.vue?vue&type=script&lang=js"
export * from "./communicationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports